import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetPaymentRewardStatusRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetPaymentRewardStatusResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getPaymentRewardStatus = (request: GetPaymentRewardStatusRequest, options?: CashRequestOptions) =>
  post<GetPaymentRewardStatusRequest, GetPaymentRewardStatusResponse>('/2.0/cash/get-payment-reward-status', request, {
    ...options,
    rejectOnError: true,
  })
